var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup43(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_43",
    "data-name": "Group 43",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.101,
    height: 35.101,
    viewBox: "0 0 35.101 35.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(14.722 14.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M6074.833,72.936a2.828,2.828,0,1,0,2.828,2.828A2.828,2.828,0,0,0,6074.833,72.936Z",
    transform: "translate(-6072.005 -72.936)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(9.155 9.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M6083.7,70.609a3.391,3.391,0,0,0-1.944-1.944,5.689,5.689,0,0,0-1.9-.353c-1.079-.049-1.4-.059-4.137-.059s-3.059.011-4.138.059a5.681,5.681,0,0,0-1.9.353,3.394,3.394,0,0,0-1.944,1.944,5.663,5.663,0,0,0-.352,1.9c-.05,1.081-.06,1.4-.06,4.138s.01,3.058.06,4.138a5.663,5.663,0,0,0,.352,1.9,3.394,3.394,0,0,0,1.944,1.944,5.681,5.681,0,0,0,1.9.353c1.08.049,1.4.059,4.138.059s3.058-.011,4.137-.059a5.688,5.688,0,0,0,1.9-.353,3.391,3.391,0,0,0,1.944-1.944,5.65,5.65,0,0,0,.352-1.9c.05-1.081.061-1.4.061-4.138s-.01-3.058-.061-4.138A5.65,5.65,0,0,0,6083.7,70.609Zm-7.983,11.3a5.258,5.258,0,1,1,5.259-5.258A5.259,5.259,0,0,1,6075.717,81.907Zm5.466-9.5a1.229,1.229,0,1,1,1.229-1.228A1.228,1.228,0,0,1,6081.184,72.41Z",
    transform: "translate(-6067.322 -68.253)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M6077.171,95.653a17.55,17.55,0,1,1,17.551-17.55A17.57,17.57,0,0,1,6077.171,95.653Zm0-33.912A16.362,16.362,0,1,0,6093.533,78.1,16.38,16.38,0,0,0,6077.171,61.741Z",
    transform: "translate(-6059.622 -60.552)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup43);
export default __webpack_public_path__ + "static/media/Group 43.e5a13df8400a65e3386d08ff13af602e.svg";
export { ForwardRef as ReactComponent };